import { render } from "./PlayerAutoExternalEmbed.vue?vue&type=template&id=f8771112"
import script from "./PlayerAutoExternalEmbed.vue?vue&type=script&lang=js"
export * from "./PlayerAutoExternalEmbed.vue?vue&type=script&lang=js"

import "./PlayerAutoExternalEmbed.vue?vue&type=style&index=0&id=f8771112&lang=scss"
script.render = render

export default script